module.exports = __webpack_public_path__ + "static/media/intro_background.e1ce1b88.jpg";